"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_ROUTE = exports.SET_ROUTE = "SET_ROUTE";
var TOGGLE_SPINNER = exports.TOGGLE_SPINNER = "TOGGLE_SPINNER";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-framework/ui-redux/app/actionTypes.js
// module id = ../lib/egov-ui-framework/ui-redux/app/actionTypes.js
// module chunks = 504